/**
 * Sentry Configuration for Frontend
 *
 * Sentry is initialized in hooks.client.ts to ensure proper integration
 * with SvelteKit's error handling.
 */

import { SentryErrorReporter } from '$shared/errors/sentry';

export function initializeCustomErrorReporting() {
  // Initialize our custom error reporter with Sentry SDK
  // This is called from hooks.client.ts after Sentry is initialized
  if (typeof window !== 'undefined') {
    try {
      // Access Sentry globally since it's imported in hooks.client.ts
      const Sentry = (globalThis as any).Sentry;
      if (Sentry) {
        SentryErrorReporter.initialize({
          captureException: Sentry.captureException,
          captureMessage: Sentry.captureMessage,
          addBreadcrumb: Sentry.addBreadcrumb
        });
        console.log('Custom error reporter initialized');
      }
    } catch (error) {
      console.warn('Failed to initialize custom error reporter:', error);
    }
  }
}